const creditResume = {
  'credit-resume-current-statement': 'Fatura',
  'credit-resume-current-statement-due-date': 'Vencimento ',
  'credit-resume-next-statement': 'Próxima fatura ',
  'credit-resume-next-statement-due-date': 'Vencimento ',
  'credit-resume-transfer': 'Transferir',
};

export default creditResume;
